import {computed, inject, Injectable, Signal} from '@angular/core';


import {RequestTools} from '@selpia/shared/data-access';
import {DimensionItemsFacade} from '@selpia/dimension-items/data-access';
import {DataChunk, Perspective} from '@selpia/shared/models';

import {DataBatchStore} from '../state/data-batch.store';
import {DTOsConverter} from '../util/dtos-converter';

@Injectable({
  providedIn: 'root',
})
export class DataBatchFacade {
  readonly #store: DataBatchStore = inject(DataBatchStore);

  readonly #dimensionItemsFacade = inject(DimensionItemsFacade);

  readonly isLoading: Signal<boolean> = computed(
    () => RequestTools.isSignalPending(this.#store.loadingStatus)() || this.#dimensionItemsFacade.isLoading(),
  );

  readonly summarizationKey: Signal<string | null> = this.#store.summarizationKey;
  readonly highlightedIds: Signal<number[]> = this.#store.highlightedIds;

  readonly dataChunks: Signal<DataChunk[] | undefined> = computed(() => {
    const dataChunksRaw = this.#store.dataChunks();

    const dimensionItems = this.#dimensionItemsFacade.allItems();

    if (!dimensionItems || !dataChunksRaw) {
      return undefined;
    }

    return dataChunksRaw.map(chunk => ({
      ...chunk,
      dimensionItems: chunk.dimensionItems.map(
        item =>
          dimensionItems.find(
            enrichedItem =>
              item.dimensionLevelName === enrichedItem.dimensionLevelName && item.code === enrichedItem.code,
          ) || item,
      ),
    }));
  });

  loadDataBatch(perspective: Perspective): void {
    this.clearData();
    const filters = DTOsConverter.buildFilters(perspective.filterDimensions, perspective.includeTotal, perspective.date);
    this.#store.loadDataBatch([perspective.focusDimensionLevel.name, filters]);
  }

  clearData(): void {
    this.#store.clearDataBatch();
  }

  loadHighlights(key: string, colouringStrategy: string): void {
    this.#store.loadHighlights([key, colouringStrategy]);
  }
}
